export type InternAuthCallback = {
  flow: "invite" | "recovery";
  hash: string;
  search: string;
};

export function detectAuthCallback(): InternAuthCallback | null {
  if (typeof window === "undefined") return null;
  const { hash, search } = window.location;
  const hashStr = hash.startsWith("#") ? hash.slice(1) : hash;
  const hashParams = new URLSearchParams(hashStr);
  const queryParams = new URLSearchParams(search);

  const hashType = hashParams.get("type");
  const queryType = queryParams.get("type");
  const flowParam = queryParams.get("flow");
  const hasHashTokens = hashParams.has("access_token") && hashParams.has("refresh_token");
  const hasCode = queryParams.has("code");
  const hasTokenHash = queryParams.has("token_hash") || queryParams.has("token");
  const hasError = queryParams.has("error") || queryParams.has("error_description");
  const explicitFlow =
    flowParam === "invite" || flowParam === "recovery" ? flowParam : null;
  const authFlow =
    hashType === "invite" || hashType === "recovery"
      ? hashType
      : queryType === "invite" || queryType === "recovery"
        ? queryType
        : null;

  const rawFlow =
    explicitFlow ||
    authFlow ||
    (hasHashTokens || hasCode || hasTokenHash || hasError ? "invite" : null);

  if (!rawFlow) return null;
  if (rawFlow !== "invite" && rawFlow !== "recovery") return null;
  if (!hasHashTokens && !hasCode && !hasTokenHash && !hasError) return null;

  return {
    flow: rawFlow,
    hash: hash || "",
    search: search || "",
  };
}

export function buildResetPasswordTarget(cb: InternAuthCallback): string {
  const params = new URLSearchParams(
    cb.search.startsWith("?") ? cb.search.slice(1) : cb.search,
  );
  params.set("flow", cb.flow);
  return `/intern/reset-password?${params.toString()}${cb.hash}`;
}
